import type { CompanyData } from '@xing-com/crate-jobs-helpers';
import { useHRContact } from '@xing-com/crate-jobs-hooks';
import { cornerRadiusL } from '@xing-com/tokens';

import { ModuleTitle } from '../module-title';

import {
  CompanyModuleWrapper,
  StyledCompanyCard,
  StyledCompanyCardSkeleton,
  StyledHRContactCard,
  StyledHRContactCardSkeleton,
} from './company-module.styles';

const moduleHeight = '271px';

type CompanyModuleProps = {
  jobId: string;
  jobSlug: string;
  company?: CompanyData;
};

export const CompanyModule: React.FC<CompanyModuleProps> = ({
  jobId,
  jobSlug,
  company,
}) => {
  const { isLoading, hrContact } = useHRContact(jobSlug, company?.id);
  if (!company) return null;

  return (
    <>
      <ModuleTitle titleKey="JOBS_JOB_DETAILS_ABOUT_COMPANY_HEADER" />
      <CompanyModuleWrapper>
        {isLoading ? (
          <StyledCompanyCardSkeleton
            height={moduleHeight}
            cornerRadius={cornerRadiusL}
          />
        ) : (
          <StyledCompanyCard
            company={company}
            isAlwaysVertical={!!hrContact}
            jobId={jobId}
          />
        )}
        {isLoading ? (
          <StyledHRContactCardSkeleton
            height={moduleHeight}
            cornerRadius={cornerRadiusL}
          />
        ) : hrContact ? (
          <StyledHRContactCard hiringContact={hrContact} jobId={jobId} />
        ) : null}
      </CompanyModuleWrapper>
    </>
  );
};
